import React, {useEffect,useState,useContext  } from "react";
import Alert from 'react-bootstrap/Alert'
import { useLocation } from 'react-router-dom'
import Context from '../context/context';
import { useNavigate  } from 'react-router-dom';


export default function Tooltip(props) {

    const  context = useContext(Context)
    let navigate = useNavigate();
    const [show, setShow] = useState(false);

    var location = useLocation();
    location = location.pathname.split("/")

    useEffect(() => {
      setShow(context.tooltip.visible)
      
      if(context.tooltip.autoClose){
        setTimeout(() => {
          setShow(false)
         
        },5000)
      }
       

    },[context.tooltip]); 

	return (<div className={"tool-tip " + context.tooltip.tipo}>
        <Alert show={show} variant={context.tooltip.variant} onClose={() => setShow(false)}   dismissible>
          {context.tooltip.title && (<Alert.Heading><h4>{context.tooltip.title}</h4></Alert.Heading>)}
          {context.tooltip.text && (<p className="mb-10">{context.tooltip.text}</p>)}
          {context.tooltip.button && (<div class="align-center"><button className="white_text" onClick={()=>{navigate(context.tooltip.redirect);setShow(false)}}>{context.tooltip.button}</button></div>)}

        </Alert>
  
    
      </div> );
}
